import axios from 'src/utils/axios';

export default function v2_actionDeletarLista(listaId) {
    return axios.delete(`/api/v2/cadastro/contatos/listas/${listaId}/deletar`);
}
